<template>
  <div>
    <div class="row" style="padding-bottom: 10px">
      <div class="col-md-2">
        <label for="starDate">{{$t('Tarixdən')}}</label>
        <el-date-picker
        format="dd.MM.yyyy"
          size="small"
          id="starDate"
          type="date"
          :clearable="false"
          v-model="item.startDate"
        ></el-date-picker>
      </div>
      <div class="col-md-2">
        <label for="endDate">{{$t('Tarixədək')}}</label>
        <el-date-picker
          size="small"
          id="endDate"
          type="date"
          :clearable="false"
          v-model="item.endDate"
        ></el-date-picker>
      </div>
      <div class="col-md-8" style="padding-bottom: 10px">
       <label>{{$t('Axtarış_növü')}}</label>
        <div class="d-flex justify-content-start">
          <div class="d-flex flex-row">
            <el-select
              style="width: 90%"
              size="small"
              v-model="item.searchType"
            >
              <el-option :label="$t('--_Bütün_--')" :value="0"></el-option>
              <el-option :label="$t('Hadisə_nömrəsi')" :value="1"></el-option>
              <el-option :label="$t('SŞ_nömrəsi')" :value="2"></el-option>
              <el-option :label="$t('DQN')" :value="3"></el-option>
              <el-option :label="$t('Məsul_şəxs')"
 :value="4"></el-option>
              <el-option :label="$t('İştirakçılara_görə')" :value="5"></el-option>
            </el-select>
            &nbsp;
            <el-input
              size="small"
              :placeholder="$t('Axtar')"
              :disabled="item.searchType == 0"
              v-model="item.searchText"
            >
              <template slot="prepend"> </template>
            </el-input>
            &nbsp;
            <el-button
              size="small"
              type="primary"
              icon="el-icon-search"
              @click="getData"
            ></el-button>
          </div>
        </div>
      </div>
      <div class="col-md-8 col-12">
        <el-checkbox @change="getData" v-model="item.noResponsible"
          >{{$t('Məsul_şəxs_təyin_olunmayıb')}} </el-checkbox
        >
      </div>
      <div class="col-md-4 col-12">
        <el-input :placeholder="$t('Axtar')" v-model="search"> </el-input>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <el-table
          :default-expand-all="true"
          v-loading="loading"
          :data="
            data.filter(
              (data) =>
                !search ||
                data.participants.toString().includes(search) ||
                data.regionName.toLowerCase().includes(search.toLowerCase()) ||
                data.clientServiceUserName
                  .toLowerCase()
                  .includes(search.toLowerCase()) ||
                data.participants.toLowerCase().includes(search.toLowerCase())
            )
          "
          style="width: 100%"
        >
          <el-table-column  type="expand">
            <template slot-scope="scope">
              <div class="row" style="margin-left: 30px">
                <div class="col-1">
                  <span style="font-size: var(--font-primary);font-weight: bold;color:#909399;position:relative;top:-3px">{{$t('İştirakçılar')}}</span>
                </div>
<div class="col-11">
                  <span style="font-size: var(--font-primary); display: inline-block;" v-html="scope.row.participants"></span>
                </div>
              </div>
            </template>
          </el-table-column>
                    <el-table-column :label="$t('Hadisə_#')" sortable prop="dispAccidentNumber" width="120">
            <template #default="scope">
              <span style="font-weight: bold">{{ scope.row.dispAccidentNumber }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('Tarix')" sortable  prop="accidentDateStr" width="150">
          </el-table-column>
          <el-table-column :label="$t('Rayon')" prop="regionName" width="250">
          </el-table-column>
          <el-table-column
            :label="$t('Məsul_şəxs')"

            prop="clientServiceUserName"
          >
          </el-table-column>
          <el-table-column
            :label="$t('Hadisə_üzrə_iş_başlanıb')"
            prop="clientServiceStartDateStr"
            width="200"
          >
          </el-table-column>
          <el-table-column
            :label="$t('Açılmış_işlərin_sayı')"
            prop="claimCount"
            width="150"
          >
          </el-table-column>
          <el-table-column align="right" fixed="right" width="30">
            <template slot="header"> </template>
            <template slot-scope="scope">
              <el-dropdown trigger="click" @command="handleCommand">
                <el-button type="text" style="padding: 0 !important">
                  <i class="fa-solid fa-ellipsis-vertical"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    :command="{ action: 'edit', row: scope.row }"
                    ><i class="fa-solid fa-pen-to-square"></i
                    >{{$t('Düzəliş')}}</el-dropdown-item
                  >
                  <el-dropdown-item
                    @refresh-table="getData"
                    :command="{ action: 'user', row: scope.row }"
                    ><i class="fa-solid fa-person-circle-check"></i>Məsul şəxs
                    seç</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <client-service-user @refresh-table="getData" ref="user" />
  </div>
</template>

<script>
import { DateToString, AddMonths, AddDays } from "../../services/helper";
import {
  GetClientServiceActiveAccidents,
} from "src/services/common";
import ClientServiceUser from "./ClientServiceUser.vue";
export default {
  components: {
    ClientServiceUser,
  },
  data() {
    return {
      loading: false,
      data: [],
      search: "",
      item: {
        startDate: null,
        endDate: null,
        searchType: 0,
        searchText: null,
        noResponsible: false,
      },
    };
  },
  methods: {
    handleCommand(command) {
      let item = command.row;
      if (command.action === "edit") this.handleEdit(item.id);
      if (command.action === "user") this.handleUser(item);
    },
    handleEdit(id) {
      this.$router.push({
        path: "accident/" + id,
      });
    },
    handleUser(item) {
      this.$refs["user"].edit(item);
    },
    getData() {
      this.loading = true;
      if (this.item.searchText == "") {
        this.item.searchText = null;
      }

      this.item.startDate = DateToString(this.item.startDate);
      this.item.endDate = DateToString(this.item.endDate);
      GetClientServiceActiveAccidents(this.item).then((response) => {
        this.loading = false;
        if (response.data.data) {
          this.data = response.data.data;
        }
      });
    },
    loadTime() {
      this.item.startDate = AddMonths(new Date(), -6);
      this.item.endDate = AddDays(new Date(), +1);
    },
  },
  mounted() {
    this.loadTime();
    this.getData();
  },
};
</script>

<style lang="css" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
</style>
